import React from "react";
import ContactUsContent from "../contents/ContactUsContent";
import MapEmbed from "../components/map/MapEmbed";

const ContactPage: React.FC = () => {
  return (
    <>
      <ContactUsContent />
   <div className="mt-6">
          <MapEmbed
            location="Ceylon Hospital, Colombo, Sri Lanka"
            zoom={15}
            title="Ceylon Hospital Location"
          />
        </div>
    </>
  );
};

export default ContactPage;
